export const MOCK_PASSWORD = "Password123!";

export const PERSONA_ID = {
  APPROVED: "approved",
  IN_REVIEW: "in-review",
  SUBSCRIBED: "subscribed",
  NOT_SUBSCRIBED: "not-subscribed",
} as const;

export type PersonaId = (typeof PERSONA_ID)[keyof typeof PERSONA_ID];

type Persona = {
  id: PersonaId;
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
};

export const PERSONAS: Record<PersonaId, Persona> = {
  [PERSONA_ID.APPROVED]: {
    id: PERSONA_ID.APPROVED,
    userId: 1101,
    email: "approved@eo-design.test",
    firstName: "Alex",
    lastName: "Mockingbird",
  },
  [PERSONA_ID.IN_REVIEW]: {
    id: PERSONA_ID.IN_REVIEW,
    userId: 1201,
    email: "in-review@eo-design.test",
    firstName: "Robin",
    lastName: "Placeholder",
  },
  [PERSONA_ID.SUBSCRIBED]: {
    id: PERSONA_ID.SUBSCRIBED,
    userId: 1301,
    email: "subscribed@eo-design.test",
    firstName: "Sam",
    lastName: "Sample",
  },
  [PERSONA_ID.NOT_SUBSCRIBED]: {
    id: PERSONA_ID.NOT_SUBSCRIBED,
    userId: 1401,
    email: "not-subscribed@eo-design.test",
    firstName: "Jordan",
    lastName: "Fixture",
  },
};

export const findPersonaById = (personaId: string) => {
  return Object.values(PERSONAS).find((persona) => {
    return persona.id === personaId;
  });
};

export const findPersonaByEmail = (email: string) => {
  const normalizedEmail = email.trim().toLowerCase();

  return Object.values(PERSONAS).find((persona) => {
    return persona.email === normalizedEmail;
  });
};
